import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { useNavigate } from "react-router-dom";
import { sanitizeSearchQuery } from "@/utils/validation";

interface SearchBarProps {
  className?: string;
  placeholder?: string;
  disableAutoFocus?: boolean;
}

const SearchBar = ({ className = "", placeholder = "Search products...", disableAutoFocus = false }: SearchBarProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      const sanitizedQuery = sanitizeSearchQuery(searchQuery.trim());
      navigate(`/products?q=${encodeURIComponent(sanitizedQuery)}`);
    }
  };


  return (
    <form onSubmit={handleSearch} className={`relative ${className}`} role="search" aria-label="Product search">
      <div className={`relative`}>
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground w-4 h-4" aria-hidden="true" />
        <Input
          id="search-input"
          name="search"
          type="search"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="pl-10 pr-4 bg-card border-border/50 focus:border-primary/50 focus:bg-background transition-all duration-200 min-h-[44px]"
          aria-label="Search for products"
          autoComplete="off"
          spellCheck="false"
          autoFocus={!disableAutoFocus}
          tabIndex={disableAutoFocus ? -1 : undefined}
        />
      </div>
    </form>
  );
};

export default SearchBar;